import { boxClasses, Drawer, drawerClasses, paperClasses, styled } from '@mui/material';

export const StyledSidebar = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'folded' })<{
  folded: boolean;
}>(({ theme, folded }) => ({
  [`&.${drawerClasses.root}`]: {
    width: folded ? '120px' : '248px',
  },
  [`&.${drawerClasses.root} > *`]: {
    fontFamily: 'Urbanist',
    fontWeight: 500,
    fontVariationSettings: '"wght" 500',
    gap: theme.spacing(5),
    paddingLeft: theme.spacing(folded ? 3 : 6),
    paddingRight: theme.spacing(folded ? 1 : 4),
    width: folded ? '120px' : '248px',
    '::-webkit-scrollbar': {
      width: '22px',
    },
    '::-webkit-scrollbar-track': {
      background: theme.palette.lwBlack[10],
      border: '8px solid white',
      borderRadius: '12px',
    },

    '::-webkit-scrollbar-thumb': {
      background: theme.palette.lwBlack[20],
      backgroundClip: 'content-box',
      border: '8px solid transparent',
      borderRadius: '12px',
      '&:hover': {
        background: theme.palette.lwBlack[40],
        backgroundClip: 'content-box',
        border: '8px solid transparent',
        borderRadius: '12px',
      },
    },
  },

  [`& .${paperClasses.root}`]: {
    borderRight: 0,
    overflowX: 'hidden',
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: folded
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
  },

  ...(folded && {
    [`&.${drawerClasses.root} section p:first-of-type`]: {
      paddingLeft: 0,
    },

    [`& .${boxClasses.root}`]: {
      justifyContent: 'center',
    },
  }),
}));
